import { SET_SALE_SOURCE, RESET_SALE_SOURCE } from './constants';

export default (state = null, { type, payload }) => {
  switch (type) {
    case SET_SALE_SOURCE: return payload;
    case RESET_SALE_SOURCE: return null;
    default: return state;
  }
};
